export default function CompletedAssessmentDirective() {
  return {
    template: require('./completed-assessment.html'),
    scope: {
      assessment: '=',
      hasIncompleteAssessments: '=',
      isNavantaUser: '=',
    },
    controller: 'CompletedAssessmentController',
    controllerAs: 'completedAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
